import user_api from '@/api/user';
import { request_list} from '@/commons/hpod';
import Vue from 'vue';

const state = {
    token: '',
    refresh: '',
    user: {},
    role: {},
    resData: {},
};

const getters = {};

const actions = {
    login({ commit, dispatch }, loginInfo) {   
        user_api.login(data => {
            commit('setToken', data);
        }, Vue.http, loginInfo);
    },
    logout({ commit, dispatch }, loginInfo) {   
        user_api.logout(data => {
        }, Vue.http, loginInfo, this.state.authentication.token);
    },
    me({ commit }) {
        request_list('me', ret => {
            commit('setUser', ret.data);
        }, Vue.http, {}, this.state.authentication.token);
    }
    
};

const mutations = {
    setToken(state, data) {
        state.resData = data;
        if(data.status_code == 400){
            return;
        }

        state.token = data.access;
        state.refresh = data.refresh;
        state.user = data.user;
        localStorage.setItem('jwt', data.access);
        localStorage.setItem('user', JSON.stringify(data.user));  
    },
    setRole(state, data) {
        state.role = data;
    },
    setUser(state, data) {
        state.user = data;
    },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
